import { apiSlice } from "../../app/apiSlice";

export const authApiSlice = apiSlice.injectEndpoints({
    endpoints: builder => ({
        login: builder.mutation({
            query: credentials => ({
                url: '/auth/login',
                method: 'POST',
                body: { ...credentials }
            })
        }),
        register: builder.mutation({
            query: credentials => ({
                url: '/auth/register',
                method: 'POST',
                body: { ...credentials }
            })
        }),
        forgetPass: builder.mutation({
            query: credentials => ({
                url: '/password-reset',
                method: 'POST',
                body: { ...credentials }
            })
        }),
        verifyCode: builder.mutation({
            query: credentials => ({
                url: '/password-reset/verify-code',
                method: 'POST',
                body: { ...credentials }
            })
        }),
        updatePass: builder.mutation({
            query: credentials => ({
                url: '/password-reset/update-password',
                method: 'POST',
                body: { ...credentials }
            })
        }),
        startProfile: builder.mutation({
            query: ({ userId, phone }) => ({
                url: '/auth/profile/start',
                method: 'POST',
                body: { userId, phone }
            })
        }),
        completeProfile: builder.mutation({
            query: ({ userId, otp, firstName, lastName }) => ({
                url: '/auth/profile/complete',
                method: 'POST',
                body: { userId, otp, firstName, lastName }
            })
        })
    })
})

export const {
    useLoginMutation,
    useRegisterMutation,
    useForgetPassMutation,
    useVerifyCodeMutation,
    useUpdatePassMutation,
    useStartProfileMutation,
    useCompleteProfileMutation
} = authApiSlice